import React, { useState, useEffect, useCallback, useRef } from 'react';
import '../../../popup/stations/Station.scss';
import { ONEDAY,ONEHR, ONEMIN, ONESEC, backgroundColor, formatDate, formatMinute, roundOneDecimal } from '../../../../../store/common';
import { useStoreContext } from '../../../../../store/context';
import moment from 'moment-timezone';
import { alertMessages, herbFMColors, hunDeadFuelColors, noColors, oneDeadFuelColors, tenDeadFuelColors, thouDeadFuelColors, woodyFMColors, gsiColors, kbdiColors } from '../../../../../constants';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { getNfdrHourly } from 'src/apis/getNfdrsCalls';
import { useAddAlert } from 'src/store/actions';
import TableHead from '@mui/material/TableHead';
import { Grid } from 'src/shared/grid';
import { Button, TableBody } from '@mui/material';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import LaunchIcon from '@mui/icons-material/Launch';
import { ROUTE_PATHS } from 'src/routes';

type NfdrHourlyTablePopUpProps = {
  id:any;
  stationMeta:any;
}

export const NfdrHourlyTablePopUp: React.FC<NfdrHourlyTablePopUpProps> = ({
  id, stationMeta
}) => {
  const [state, dispatch] = useStoreContext();
  const [currHr, setCurrHr] = useState('');
  const [modifiedContents, setModifiedContents] = useState<any[]>([]);
  const today = new Date();
  const [currDate, setCurrDate] = useState(today.toISOString().slice(0, today.toISOString().indexOf('T')))
  const addAlert = useAddAlert(dispatch);
  const scrollRef = useRef<HTMLTableElement | HTMLDivElement | null>(null);

  const [nfdrsHourlyFailCount, setNfdrsHourlyFailCount] = useState<number>(0);

  const fillMissingHours=useCallback((data: any[], startTime: any, endTime: any)=>{
    const filledData:any[] = [];
    let currentTime = moment.utc(startTime).set({hour:0, minute:0, second:0})
    const endMoment = moment.utc(endTime)
    let minuteSet = 0;
    if(data.length>0){
      minuteSet = moment(data[0].observation_time).minute()
    }
    const fillInTimeMinuteWhenEmpty = (currTime: any)=>{
      if(moment()>currTime){
        //observation
        const hr = moment(currentTime).utc().hour()
        if (minuteSet < 30) {
          return moment(currTime).set({ hour: hr, minute: minuteSet }).utc().utcOffset(stationMeta.time_zone_offset).format();
        }
        else {
          return moment(currTime).subtract(1, 'hour').set({ minute: minuteSet }).utc().utcOffset(stationMeta.time_zone_offset).format();
        }
      }
      else{
        //Forcast
        return moment(currTime).utc().utcOffset(stationMeta.time_zone_offset).format()
      }
    }

    if(stationMeta?.time_zone_offset){
      while(currentTime.isBefore(endMoment)){
        const currentHour = currentTime.toISOString();
        const existingData:any = data.find(item=>item.display_hour === currentHour);
        if(existingData){
          filledData.push(existingData);
        }
        else{
          filledData.push({
            station_id: stationMeta.station_id,
            observation_time: currentHour,
            display_hour: currentHour,
            observation_time_lst: fillInTimeMinuteWhenEmpty(currentTime),
            display_hour_lst: moment(currentTime).utc().utcOffset(stationMeta.time_zone_offset).format(),
            nfdr_type: moment()>currentTime? 'O':'F',
            one_hr_tl_fuel_moisture: null,
            ten_hr_tl_fuel_moisture:null,
            hun_hr_tl_fuel_moisture: null,
            thou_hr_tl_fuel_moisture: null,
            ignition_component:null,
            spread_component: null,
            energy_release_component: null,
            burning_index:null,
            herbaceous_lfi_fuel_moisture:null,
            woody_lfi_fuel_moisture:null,
            gsi: null,
            kbdi: null
          })
        }
        currentTime.add(1, 'hour');
      }
    }
    return filledData;
  },[stationMeta]);

  const nfdrCallbackHourly = useCallback((countFail: number) => {
    (async () => {
      try {
        const varRequest = {
          stationIds: id.toString(),
          zoomLevel: 5,
          startDate: moment(state.currentSliderDate - (3 * ONEDAY) - (30 * ONEMIN)).utc().format('YYYY-MM-DD'),
          endDate: moment(state.currentSliderDate + (3 * ONEDAY) + (30 * ONEMIN) - ONESEC).utc().format('YYYY-MM-DD'),
          startHour: 0,
          endHour: 23,
          page: 0,
          perPage: 3000000,
          fuelModel: state.nfdrFuelModel,
          sortBy: 'observation_time',
          sortOrder: 'asc',
        };
        const response: any = await getNfdrHourly(varRequest, addAlert, state?.user);
        setNfdrsHourlyFailCount(0)
        if (response.data?.length>0) {
          const responseFirstObj = moment(response.data[0]?.observation_time).utc().set({minute:0, second:0, millisecond:0}).format();
          const responseLastObj = moment(response.data[response.data.length-1]?.observation_time).utc().set({minute:0, second:0, millisecond:0}).format();

          const fill = responseFirstObj!==responseLastObj? 
            fillMissingHours(response.data,moment(state.currentSliderDate - (3 * ONEDAY)+ONEHR).utc().format(), moment(state.currentSliderDate + (3 * ONEDAY)).utc().format())
            :
            fillMissingHours(response.data,moment(state.currentSliderDate - (3 * ONEDAY)).utc().format(), responseLastObj);
          const utcOffset = stationMeta?.time_zone_offset;
          const currentSlideinUTC = moment.utc(state.currentSliderDate);
          const currentSlideinLST = currentSlideinUTC.utc().utcOffset(utcOffset*60);
          setCurrHr(currentSlideinLST.format('HH'));
          setCurrDate(currentSlideinLST.format('YYYY-MM-DD'));

          const convert_response = fill.map((item: any) => {
            let thisHour = item.observation_time_lst.substring(11, 13);
            let displayHourDateTime = item.display_hour_lst;
            let displayDate = item.display_hour_lst.substring(0, 10);
            let displayHour = item.display_hour_lst.substring(11, 13);

            let oneHrFMColors = backgroundColor(item.one_hr_tl_fuel_moisture===null? -500000: Number(item.one_hr_tl_fuel_moisture), oneDeadFuelColors);
            let tenHrFMColors = backgroundColor(item.ten_hr_tl_fuel_moisture===null? -500000: Number(item.ten_hr_tl_fuel_moisture), tenDeadFuelColors);
            let hunHrFMColors = backgroundColor(item.hun_hr_tl_fuel_moisture===null? -500000: Number(item.hun_hr_tl_fuel_moisture), hunDeadFuelColors);
            let thouHrFMColors = backgroundColor(item.thou_hr_tl_fuel_moisture===null? -500000: Number(item.thou_hr_tl_fuel_moisture), thouDeadFuelColors);
            let igColors = backgroundColor(item.ignition_component===null? -500000: Number(item.ignition_component), noColors);
            let scColors = backgroundColor(item.spread_component===null? -500000: Number(item.spread_component), noColors);
            let ercColors = backgroundColor(item.energy_release_component===null? -500000: Number(item.energy_release_component), noColors);
            let biColors = backgroundColor(item.burning_index===null? -500000: Number(item.burning_index), noColors);
            let herbColors = backgroundColor(item.herbaceous_lfi_fuel_moisture===null? -500000: Number(item.herbaceous_lfi_fuel_moisture), herbFMColors);
            let woodyColors = backgroundColor(item.woody_lfi_fuel_moisture===null? -500000: Number(item.woody_lfi_fuel_moisture), woodyFMColors);
            let gsiColors_here = backgroundColor(item.gsi===null? -500000: Number(item.gsi), gsiColors);
            let kbdiColors_here = backgroundColor(item.gsi===null? -500000: Number(item.kbdi), kbdiColors);
            return (
              {
                ...item,
                observation_lst_hour: thisHour,
                lst_display_hour_datetime: displayHourDateTime,
                lst_display_date: displayDate,
                lst_display_hour: displayHour,
                dateNum: Number(moment(item.observation_time_lst)),
                oneFMbg: oneHrFMColors.bg,
                oneFMtxt: oneHrFMColors.text,
                tenFMbg: tenHrFMColors.bg,
                tenFMtxt: tenHrFMColors.text,
                hunFMbg: hunHrFMColors.bg,
                hunFMtxt: hunHrFMColors.text,
                thouFMbg: thouHrFMColors.bg,
                thouFMtxt: thouHrFMColors.text,
                igBg: igColors.bg,
                igTxt: igColors.text,
                scBg: scColors.bg,
                scTxt: scColors.text,
                ercBg: ercColors.bg,
                ercTxt: ercColors.text,
                biBg: biColors.bg,
                biTxt: biColors.text,
                herbBg: herbColors.bg,
                herbTxt: herbColors.text,
                woodyBg: woodyColors.bg,
                woodTxt: woodyColors.text,
                gsiBg: gsiColors_here.bg,
                gsiTxt: gsiColors_here.text,
                kbdiBg: kbdiColors_here.bg,
                kbdiTxt: kbdiColors_here.text,
              }
            )
          });
          const sorted = convert_response.sort(({ dateNum: a }, { dateNum: b }) => a - b);
          setModifiedContents(sorted)
        }
        else{
          const responseFirstObj = moment(state.currentSliderDate - (3 * ONEDAY) - (30 * ONEMIN)).utc().set({minute:0, second:0, millisecond:0}).format();
          const responseLastObj = moment(state.currentSliderDate + (3 * ONEDAY) + (30 * ONEMIN) - ONESEC).utc().set({minute:0, second:0, millisecond:0}).format();

          const fill = responseFirstObj!==responseLastObj? 
            fillMissingHours(response.data,moment(state.currentSliderDate - (3 * ONEDAY)+ONEHR).utc().format(), moment(state.currentSliderDate + (3 * ONEDAY)).utc().format())
            :
            fillMissingHours(response.data,moment(state.currentSliderDate - (3 * ONEDAY)).utc().format(), responseLastObj);
          const utcOffset = stationMeta?.time_zone_offset;
          const currentSlideinUTC = moment.utc(state.currentSliderDate);
          const currentSlideinLST = currentSlideinUTC.utc().utcOffset(utcOffset*60);
          setCurrHr(currentSlideinLST.format('HH'));
          setCurrDate(currentSlideinLST.format('YYYY-MM-DD'));

          const convert_response = fill.map((item: any) => {
            let thisHour = item.observation_time_lst.substring(11, 13);
            let displayHourDateTime = item.display_hour_lst;
            let displayDate = item.display_hour_lst.substring(0, 10);
            let displayHour = item.display_hour_lst.substring(11, 13);

            let oneHrFMColors = backgroundColor(item.one_hr_tl_fuel_moisture===null? -500000: Number(item.one_hr_tl_fuel_moisture), oneDeadFuelColors);
            let tenHrFMColors = backgroundColor(item.ten_hr_tl_fuel_moisture===null? -500000: Number(item.ten_hr_tl_fuel_moisture), tenDeadFuelColors);
            let hunHrFMColors = backgroundColor(item.hun_hr_tl_fuel_moisture===null? -500000: Number(item.hun_hr_tl_fuel_moisture), hunDeadFuelColors);
            let thouHrFMColors = backgroundColor(item.thou_hr_tl_fuel_moisture===null? -500000: Number(item.thou_hr_tl_fuel_moisture), thouDeadFuelColors);
            let igColors = backgroundColor(item.ignition_component===null? -500000: Number(item.ignition_component), noColors);
            let scColors = backgroundColor(item.spread_component===null? -500000: Number(item.spread_component), noColors);
            let ercColors = backgroundColor(item.energy_release_component===null? -500000: Number(item.energy_release_component), noColors);
            let biColors = backgroundColor(item.burning_index===null? -500000: Number(item.burning_index), noColors);
            let herbColors = backgroundColor(item.herbaceous_lfi_fuel_moisture===null? -500000: Number(item.herbaceous_lfi_fuel_moisture), herbFMColors);
            let woodyColors = backgroundColor(item.woody_lfi_fuel_moisture===null? -500000: Number(item.woody_lfi_fuel_moisture), woodyFMColors);
            let gsiColors_here = backgroundColor(item.gsi===null? -500000: Number(item.gsi), gsiColors);
            let kbdiColors_here = backgroundColor(item.gsi===null? -500000: Number(item.kbdi), kbdiColors);

            return (
              {
                ...item,
                observation_lst_hour: thisHour,
                lst_display_hour_datetime: displayHourDateTime,
                lst_display_date: displayDate,
                lst_display_hour: displayHour,
                dateNum: Number(moment(item.observation_time_lst)),
                oneFMbg: oneHrFMColors.bg,
                oneFMtxt: oneHrFMColors.text,
                tenFMbg: tenHrFMColors.bg,
                tenFMtxt: tenHrFMColors.text,
                hunFMbg: hunHrFMColors.bg,
                hunFMtxt: hunHrFMColors.text,
                thouFMbg: thouHrFMColors.bg,
                thouFMtxt: thouHrFMColors.text,
                igBg: igColors.bg,
                igTxt: igColors.text,
                scBg: scColors.bg,
                scTxt: scColors.text,
                ercBg: ercColors.bg,
                ercTxt: ercColors.text,
                biBg: biColors.bg,
                biTxt: biColors.text,
                herbBg: herbColors.bg,
                herbTxt: herbColors.text,
                woodyBg: woodyColors.bg,
                woodTxt: woodyColors.text,
                gsiBg: gsiColors_here.bg,
                gsiTxt: gsiColors_here.text,
                kbdiBg: kbdiColors_here.bg,
                kbdiTxt: kbdiColors_here.text,
              }
            )
          });
          const sorted = convert_response.sort(({ dateNum: a }, { dateNum: b }) => a - b);
          setModifiedContents(sorted);
          
        }

      }
      catch (error) {
        console.log('error', error);
        setNfdrsHourlyFailCount(countFail+1)
        addAlert({
          id: '',
          message: alertMessages.retrievingStationData,
          type: 'error-info',
          icon: 'fa-exclamation-triangle'
        })
      }
    })();
  }, [addAlert, state.currentSliderDate, id,setNfdrsHourlyFailCount, state?.user,
     fillMissingHours, state.nfdrFuelModel, stationMeta?.time_zone_offset]);

  useEffect(() => {
    if(stationMeta?.time_zone || (nfdrsHourlyFailCount>0 && nfdrsHourlyFailCount<4)){
      nfdrCallbackHourly(nfdrsHourlyFailCount);
    }
  }, [nfdrCallbackHourly, stationMeta?.time_zone, nfdrsHourlyFailCount]);

  useEffect(() => {
    requestAnimationFrame(scrollToCurrentHour);
  }, [modifiedContents])

  const scrollToCurrentHour = () =>{
    const element = document.getElementById('currentTime') as HTMLElement | null;
    const container = scrollRef.current;

    if(!element || !container) return;
    const elementRight = element.offsetLeft + element.offsetWidth;
    const containerWidth = container.offsetWidth;
    const left = elementRight - containerWidth;

    container.scrollTo({
      left,
      behavior: "smooth"
    });
  };

  const goToTable = () =>{
    window.open(`${ROUTE_PATHS.table}/fireDanger/${stationMeta.station_id}`, '_blank' )
  }

  return (
    <div>
      <Grid row gap="md" >
        <Grid desktop={{ col: 8 }} style={{ paddingBottom: '5px' }}>
          <Grid
            desktop={{col:12}} style={{paddingBottom:'5px'}}>
            <Button
              variant="contained" 
              style={{ fontSize: '12px', width:'100%'}}
              onClick ={()=>scrollToCurrentHour()}
            >
              <KeyboardDoubleArrowLeftIcon/> Scroll to Current Observation <KeyboardDoubleArrowRightIcon/>
            </Button>
          </Grid>
        </Grid>
        <Grid desktop={{ col: 4 }} style={{ paddingBottom: '5px' }}>
          <Button onClick={goToTable} style={{ textTransform: 'capitalize'}}>Go To Table <LaunchIcon fontSize='small' /></Button>
        </Grid>
      </Grid>
    <TableContainer ref={scrollRef} style={{ maxHeight: 500, overflowX: "auto", overflowY: 'hidden'}} className="smooth-scrollbar">
      <Table className='table-popup' style={{ tableLayout: "auto" }} >
        <TableHead style={{ height: '0px', position: 'sticky', zIndex: 100, left: 0 }}>
          <TableRow>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '32px',position: 'sticky', zIndex: 50, top:0, backgroundColor:'#A1A1A1'}}>DATE/HOUR</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px',position: 'sticky', width:'100px', zIndex: 50, top:'30px', backgroundColor:'#A1A1A1'}}>HR:MIN (LST)</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>1 hr FM</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>10 hr FM</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>100 hr FM</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>1000 hr FM</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>KBDI</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>Herb FM</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>Woody FM</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>GSI</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>IC</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>SC</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '30px', backgroundColor:'#A1A1A1'}}>ERC</TableCell>
            <TableCell style={{border: '1px solid #bbbbbb', fontWeight: 700, fontSize:'12px', height: '34px', backgroundColor:'#A1A1A1'}}>BI</TableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow style={{width: '70px'}}/>
          {/*IMPORTANT: these table rows are actually columns- updated in Stations.scss*/}
          {modifiedContents?.length > 1 &&
            modifiedContents.map((item: any, y) => (

              <TableRow style={{ width: '100px', }}
                key ={`${item.lst_display_date}-${y}`}
                id={item.lst_display_date === (currDate) && item.lst_display_hour.toString() === (currHr) ? 'currentTime' : ''}
                className={item.lst_display_date === (currDate) && item.lst_display_hour.toString() === (currHr) ? (item.nfdr_type === 'F' ? 'selected-popup-dashed' : 'selected-popup') : ''}
              >
                <TableCell style={{ fontSize: '12px', height: '30px',position: 'sticky', zIndex: 50, top:0, backgroundColor: 'white'}}
                  className={item.nfdr_type === 'F' ? 'forecast' : 'obs'}
                  key={`${item.lst_display_hour_datetime}-${y}`}>
                    {formatDate(item.lst_display_hour_datetime)}
                </TableCell>


                <TableCell
                  style={{ height: '30px', position: 'sticky', zIndex: 50, top: '30px', backgroundColor: 'white', }}
                  className={item.nfdr_type === 'F' ? 'forecast' : 'obs'}
                  key={`${item.observation_lst_hour}-${y}`}
                >
                  {item.observation_lst_hour.toString().length === 2 ? item.observation_lst_hour : "0" + item.observation_lst_hour + ` ${stationMeta?.time_zone}`}
                  :{formatMinute(item.observation_time_lst) + ` ${stationMeta?.time_zone}`}
                </TableCell> 
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`oneHr-${item.one_hr_tl_fuel_moisture}--${item.oneFMbg}-${y}`} style={item.oneFMbg ? { height: '30px', backgroundColor: item.oneFMbg, color: item.oneFMtxt } : { height: '30px' }}>{item.one_hr_tl_fuel_moisture === null ? "●●●" : roundOneDecimal(item.one_hr_tl_fuel_moisture)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`tenHr-${item.ten_hr_tl_fuel_moisture}--${item.tenFMbg}-${y}`} style={item.tenFMbg ? { height: '30px', backgroundColor: item.tenFMbg, color: item.tenFMtxt } : { height: '30px' }}>{item.ten_hr_tl_fuel_moisture === null ? "●●●" : roundOneDecimal(item.ten_hr_tl_fuel_moisture)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`hunHr-${item.hun_hr_tl_fuel_moisture}--${item.hunFMbg}-${y}`} style={item.hunFMbg ? { height: '30px', backgroundColor: item.hunFMbg, color: item.hunFMtxt } : { height: '30px' }}>{item.hun_hr_tl_fuel_moisture === null ? "●●●" : roundOneDecimal(item.hun_hr_tl_fuel_moisture)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`thouHr-${item.thou_hr_tl_fuel_moisture}--${item.thouFMbg}-${y}`} style={item.thouFMbg ? { height: '30px', backgroundColor: item.thouFMbg, color: item.thouFMtxt } : { height: '30px' }}>{item.thou_hr_tl_fuel_moisture === null ? "●●●" : roundOneDecimal(item.thou_hr_tl_fuel_moisture)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`kbdi-${item.kbdi}--${item.kbdi}-${y}`} style={item.kbdiBg ? { height: '30px', backgroundColor: item.kbdiBg, color: item.kbdiTxt } : { height: '30px' }}>{item.kbdi === null ? "●●●" : item.kbdi} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`herbFM-${item.herbaceous_lfi_fuel_moisture}--${item.herbBg}-${y}`} style={item.herbBg ? { height: '30px', backgroundColor: item.herbBg, color: item.herbTxt } : { height: '30px' }}>{item.herbaceous_lfi_fuel_moisture === null ? "●●●" : roundOneDecimal(item.herbaceous_lfi_fuel_moisture)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`woodyFM-${item.woody_lfi_fuel_moisture}--${item.woodyBg}-${y}`} style={item.woodyBg ? { height: '30px', backgroundColor: item.woodyBg, color: item.woodTxt } : { height: '30px' }}>{item.woody_lfi_fuel_moisture === null ? "●●●" : roundOneDecimal(item.woody_lfi_fuel_moisture)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`gsi-${item.gsi}--${item.gsiBg}-${y}`} style={item.gsiBg ? { height: '30px', backgroundColor: item.gsiBg, color: item.gsiTxt } : { height: '30px' }}>{item.gsi === null ? "●●●" : item.gsi} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`ic-${item.ignition_component}--${item.igBg}-${y}`} style={item.igBg ? { height: '30px', backgroundColor: item.igBg, color: item.igTxt } : { height: '30px' }}>{item.ignition_component === null ? "●●●" : roundOneDecimal(item.ignition_component)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`sc-${item.spread_component}--${item.scBg}-${y}`} style={item.scBg ? { height: '30px', backgroundColor: item.scBg, color: item.scTxt } : { height: '30px' }}>{item.spread_component === null ? "●●●" : roundOneDecimal(item.spread_component)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`erc-${item.energy_release_component}--${item.ercBg}-${y}`} style={item.ercBg ? { height: '30px', backgroundColor: item.ercBg, color: item.ercTxt } : { height: '30px' }}>{item.energy_release_component === null ? "●●●" : roundOneDecimal(item.energy_release_component)} </TableCell>
                <TableCell className={item.nfdr_type === 'F' ? 'forecast' : 'obs'} key={`bi-${item.burning_index}--${item.biBg}-${y}`} style={item.biBg ? { height: '30px', backgroundColor: item.biBg, color: item.biTxt } : { height: '30px' }}>{item.burning_index === null ? "●●●" : roundOneDecimal(item.burning_index)} </TableCell>

              </TableRow>
            ))
          }
          </TableBody>

      </Table>
    </TableContainer>
    </div>
  )
}